import { IUserInfo } from "../DataStorage/IUserInfo";

export interface IUserContextPlugin {
    getCurrentUser(): IUserInfo;

    getCurrentChangeSet(): string | undefined;
}

export class DefaultUserContextPlugin implements IUserContextPlugin {
    getCurrentUser(): IUserInfo {
        return { userEmail: "system@appglue.com", teamName: "appglue" };
    }

    getCurrentChangeSet(): string | undefined {
        return undefined;
    }
}
